import React from 'react';
import { motion } from 'framer-motion';
import { Check, X } from 'lucide-react';
const notThis = ['Not a random collection of boxing drills.', 'Not a theoretical book that still leaves you building the actual sessions.', 'Not a generic fitness program disguised as boxing coaching.'];
export function SolutionReveal() {
  return <section className="py-20 px-4 bg-canvas relative overflow-hidden" data-id="element-274" data-mp="1mrh0ceyq7c4v">
      <div className="max-w-4xl mx-auto text-center" data-id="element-275" data-mp="z2fpym6c1qwy">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-276" data-mp="z37jlrgddekl">
          <p className="inline-block px-3 py-1 rounded-full bg-gold text-canvas text-xs font-bold tracking-widest mb-5" data-id="element-277" data-mp="13zy1mkbqik8n">
            6-IN-1
          </p>
          <h2 className="text-2xl md:text-4xl font-display font-bold mb-4 text-white" data-id="element-278" data-mp="2jfeqj5jvmr5u">
            The complete ready-to-coach boxing system for coaches worldwide
          </h2>
          <p className="text-base md:text-lg text-mist mb-10" data-id="element-279" data-mp="2buxhzdrtmtci">
            6 complete volumes · 150 ready-to-coach sessions · 5 bonus guides · Ready to use today
          </p>
        </motion.div>
        <div className="grid md:grid-cols-2 gap-6 text-left" data-id="element-280" data-mp="2kxowjmfzu58d">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          ease: [0.23, 1, 0.32, 1]
        }} className="space-y-3 bg-section p-6 rounded-2xl border border-line" data-id="element-281" data-mp="2pv882elb43wm">
            {notThis.map(item => <div key={item} className="flex items-start gap-3" data-id="element-282" data-mp="224kyzpznn88h">
                <X className="text-steel shrink-0 mt-0.5" size={18} aria-hidden="true" data-id="element-283" data-mp="26ww1n0ls584q" />
                <p className="text-steel text-sm" data-id="element-284" data-mp="19hrrmorrfapi">{item}</p>
              </div>)}
          </motion.div>
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          ease: [0.23, 1, 0.32, 1]
        }} className="bg-card p-6 rounded-2xl border border-gold/50" data-id="element-285" data-mp="1ef9vi0qx6zqn">
            <div className="flex items-start gap-3" data-id="element-286" data-mp="2qihkvsar1r8x">
              <Check className="text-gold shrink-0 mt-1" size={20} aria-hidden="true" data-id="element-287" data-mp="2mhxl0gysk9j3" />
              <div data-id="element-288" data-mp="2mkbfanlndhpl">
                <p className="text-white font-display font-bold text-lg mb-2" data-id="element-289" data-mp="1ys385zeh2kyu">
                  A complete professional coaching system.
                </p>
                <p className="text-mist text-base leading-relaxed" data-id="element-290" data-mp="1tv4hjqu0ow5e">
                  Walk into the gym prepared, structured and clear about exactly what you want your
                  athletes to develop.
                </p>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}